export default "__VITE_ASSET__yvyZHKt4__"